import {
  AutoComplete,
  Avatar,
  Button,
  Drawer,
  Form,
  Input,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import Details from "./Details";
import Empty from "../common/Empty";
import AddRestrictProduct from "./AddRestrictProduct";
import { responseNotification } from "../../utils/notify";
import moment from "moment";
import { debounce } from "lodash";

const RestrictedProductList = () => {
  const router = useLocation();
  const [status, setStatus] = useState("");
  const [barCode, setBarCode] = useState<string>();
  const [type, setType] = useState("JC_MART");
  const page = getParamValue(router.search, "page");
  const [limit, setLimit] = useState(20);

  const [productData, setProductData] = useState({
    loading: false,
    data: null,
  });

  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [selectedProduct, setSelectedProduct] = useState(undefined);
  const [selectedProductForEdit, setSelectedProductForEdit] =
    useState(undefined);
  const [visible, setVisible] = useState(undefined);
  // const [confirmLoading, setConfirmLoading] = useState(false);

  const [form] = Form.useForm();
  const loc = useLocation();

  const reseAllFieldData = () => {
    setStatus("");
    setType("JC_MART");
    form.resetFields();
    setBarCode("");
  };

  const getProduct = useCallback(async () => {
    setProductData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/product-restrict/all` +
          (limit ? `?limit=${limit}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setProductData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setProductData({ loading: false, data: [] });
        console.error("Products: Error", err);
      });
  }, [barCode, limit, page]);

  const getProductOptions = useCallback(
    async (barCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_ORDER_API}`;

      const res = await axios.get(
        `${encodedUri}/product-restrict/all?` +
          `page=${0}` +
          (limit ? `&limit=${limit}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.products?.map(
          (product: { name: any; barCode: any }) => {
            return {
              value: product?.barCode,
              label: product?.name,
            };
          }
        ),
      });
    },
    [type, status]
  );

  useEffect(() => {
    getProduct();
  }, [getProduct]);

  const onStatusChange = async (barCode, val) => {
    if (barCode) {
      await fetch(`${process.env.REACT_APP_ORDER_API}/product-restrict`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          barCode: barCode,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getProduct();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  const fetchRef = useRef(null);
  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "product") getProductOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getProductOptions]);

  useEffect(() => {
    if (visible) {
      setSelectedProduct(undefined);
      setSelectedProductForEdit(undefined);
    }
  }, [selectedProduct, selectedProductForEdit, visible]);

  useEffect(() => {
    setSelectedProduct(undefined);
    setSelectedProductForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedProduct(null);
    setSelectedProductForEdit(null);
    getProduct();
  };

  return (
    <React.Fragment>
      <TopHeading {...productData?.data?.totalElements} refetch={getProduct} />
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="barcode_search" initialValue={barCode}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "product")}
              onSelect={(val) => setBarCode(val)}
              options={productBarcodeOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                productBarcodeOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Search by BarCode"
                onSearch={(val) => {
                  setBarCode(val);
                }}
                enterButton
                loading={productBarcodeOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Product</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Barcode</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Duration</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Quantity</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {productData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {productData?.data?.products?.length ? (
                    productData?.data?.products?.map(
                      (product: any, index: any) => (
                        <React.Fragment key={index}>
                          <div
                            className="single-product-wrapper"
                            // onClick={() => setSelectedProduct(product)}
                          >
                            <div className="single-product">
                              <Avatar
                                shape="square"
                                size={45}
                                src={product?.image}
                                className="mr-3"
                              />
                              <span className="name">{product?.name}</span>
                            </div>
                            <div className="single-product">
                              <span className="name">{product?.barCode}</span>
                            </div>
                            <div className="single-product">
                              <span className="name text-capitalize">
                                {moment
                                  .duration({
                                    minutes: product?.durationInMinutes,
                                  })
                                  .humanize()}
                              </span>
                            </div>
                            <div className="single-product">
                              <span className="name">{product?.quantity}</span>
                            </div>
                            <div className="single-product">
                              <Switch
                                checkedChildren={<CheckOutlined />}
                                unCheckedChildren={<CloseOutlined />}
                                defaultChecked={product?.isActive}
                                onChange={(val, e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  onStatusChange(product?.barCode, val);
                                }}
                              />
                            </div>
                            <div className="single-product">
                              <button
                                className="btn btn-sm btn-warning mx-1"
                                onClick={() =>
                                  setSelectedProductForEdit(product)
                                }
                              >
                                <EditOutlined />
                              </button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Products" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={selectedProductForEdit ? "Edit Product" : "Product Details"}
            width={500}
            onClose={onClose}
            visible={selectedProduct || selectedProductForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            {selectedProductForEdit ? (
              <AddRestrictProduct
                visibleData={selectedProductForEdit}
                onCloseMethod={onClose}
              />
            ) : (
              <Details BannerDetails={selectedProduct} />
            )}
          </Drawer>

          <PaginationTwo
            {...productData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default RestrictedProductList;
